import React, { useState } from "react";
import { Modal, Form, Input, message } from "antd";
import { useSaveAppAsTemplateMutation, useCreateAppConfigTemplateMutation } from "../hooks/useAppsQueries";

interface PresetRoutingData {
  templateId?: string;
  greyType?: string;
  endpointMappings?: any[];
  landingRoutes?: any[];
}

interface SaveAsTemplateModalProps {
  open: boolean;
  onClose: () => void;
  appId?: string;
  /** Повертає актуальний роутинг з форми на момент збереження */
  getFormData?: () => PresetRoutingData;
}

export const SaveAsTemplateModal: React.FC<SaveAsTemplateModalProps> = ({
  open,
  onClose,
  appId,
  getFormData,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const saveAppAsTemplate = useSaveAppAsTemplateMutation();
  const createTemplate = useCreateAppConfigTemplateMutation();

  const handleSubmit = async () => {
    const values = await form.validateFields();
    setLoading(true);
    try {
      const routing = getFormData?.();
      if (appId) {
        await saveAppAsTemplate.mutateAsync({
          appId,
          data: {
            name: values.name,
            description: values.description,
            ...routing,
          },
        });
      } else {
        await createTemplate.mutateAsync({
          name: values.name,
          description: values.description,
          ...routing,
        });
      }
      message.success("Пресет роутингу збережено");
      form.resetFields();
      onClose();
    } catch {
      message.error("Помилка збереження пресету");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title="Зберегти як пресет роутингу"
      open={open}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      onOk={handleSubmit}
      confirmLoading={loading}
      okText="Зберегти"
      cancelText="Скасувати"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="name"
          label="Назва пресету"
          rules={[{ required: true, message: "Введіть назву пресету" }]}
        >
          <Input placeholder="Мій пресет" />
        </Form.Item>
        <Form.Item name="description" label="Опис (необов'язково)">
          <Input.TextArea rows={3} placeholder="Короткий опис пресету" />
        </Form.Item>
      </Form>
    </Modal>
  );
};
